import Divider from "@mui/material/Divider";
import ClearIcon from "@mui/icons-material/Clear";
import SaveIcon from "@mui/icons-material/Save";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { RotateSpinner } from "react-spinners-kit";

const BranchForm = (props) => {
  return (
    <Dialog open={true} onClose={props.handleClose}>
      <DialogTitle>
        {props.edit ? "Edit Branch Details" : "Add a new Branch"}
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              margin="dense"
              label="Branch Name"
              name="Name"
              type="text"
              fullWidth
              onChange={props.handleChange}
              value={props.branch.Name}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              margin="dense"
              name="Prefix"
              label="Prefix"
              type="text"
              fullWidth
              helperText="Add Branch Prefix"
              onChange={props.handleChange}
              value={props.branch.Prefix}
            />
          </Grid>
        </Grid>
      </DialogContent>

      <Divider />

      <DialogActions>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{
            width: "100%",
          }}
        >
          <Button
            variant="outlined"
            onClick={props.close}
            color="primary"
            size="large"
            startIcon={<ClearIcon />}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              if (!props.loading) {
                props.save();
              }
            }}
            color="secondary"
            size="large"
            startIcon={props.loading ? null : <SaveIcon />}
          >
            {props.loading ? (
              <>
                <RotateSpinner size={20} color="#fff" />
                <span style={{ marginRight: "2px" }}>Saving</span>
              </>
            ) : (
              <span>Save</span>
            )}
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};

export default BranchForm;
